// tslint:disable-next-line:no-any
import { Component, OnInit } from '@angular/core';

import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'je-provider-integration',
    templateUrl: './provider-integration.component.html',
    imports: [RouterOutlet],
    standalone: true,
})
export class ProviderIntegrationComponent implements OnInit {
    public isLoading = false;

    public ngOnInit(): void {
        this.isLoading = true;
        Promise.all([
            this.loadScript('https://www.datgroup.com/valuateNG/app/js/external.js'),
            this.loadScript('https://www.dat.de/sphinx/js/lazyload.js'),
            this.loadScript('https://www.dat.de/sphinx/js/externalSphinx.js'),
        ])
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.log(err);
                this.isLoading = false;
            });
    }

    public loadScript(url: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const node = document.createElement('script');
            node.src = url;
            node.type = 'text/javascript';
            node.async = true;
            document.getElementsByTagName('head')[0].appendChild(node);
            node.onload = () => {
                resolve();
            };
            node.onerror = (err: any) => {
                resolve(err);
            };
        });
    }
}
